<template>
  <div class="casino-group-container" :class="[group.type.toLowerCase()]">
    <div class="group-header">
      <div v-if="!gridView" class="group-top-ten-logo">
        <img class="logo-holder-image" :src="mediaServer('/static/casino/groups/' + group.externalId + '/assets/logo/' + group.externalId + '.svg')" alt="" loading="lazy" />
      </div>
      <div v-if="!gridView" class="see-all"><router-link :to="{ name: 'casino-page', params: { slug: group.slug }}">{{$t('Casino.See.All')}}</router-link></div>
    </div>
    <div v-if="group" :data-gid="group.groupId" class="slider-container" :id="'slider-container-' + group.groupId">
      <casino-slider v-if="!gridView" :section="group.type.toLowerCase()" :group="setGroupSliderItemLimit(group)" :gamesByGroup="filterGamesInfoDataByGroup(group.gameIds)"></casino-slider>
      <casino-grid-view v-if="gridView" :data="filterGamesInfoDataByGroup(this.group.gameIds)" :groupData="this.group"></casino-grid-view>
    </div>
  </div>
</template>
<script>
import CasinoSlider from '@/components/igaming/partials/casinoSlider.vue'
import Casino from '@/components/mixins/Casino'
import Url from '@/components/mixins/Url'
import CasinoGridView from '@/components/igaming/partials/casinoGridView.vue'

export default {
  name: 'casinoTopGames',
  props: ['group', 'groupRender', 'gridView'],
  mixins: [
    Casino,
    Url
  ],
  components: {CasinoGridView, CasinoSlider},
  data () {
    return {
      dataId: Math.floor(Math.random() * 100),
      imagePath: false
    }
  },
  computed: {},
  methods: {},
  mounted () {
    const imageName = this.group.type.toLowerCase()
    this.imagePath = `~@/assets/images/casino/top_${imageName}_title.svg`
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoTopGames.vue